export type Lang = "de" | "en" | "ru" | "uk" | "it";

export type LocalizedText = string | ({ de: string } & Partial<Record<Lang, string>>);

/** Produktseitige Übersetzungs-Dictionaries (bleiben im jeweiligen Produkt). */
export type TranslationMaps = { de: Record<string, string>; en: Record<string, string> } & Partial<Record<Lang, Record<string, string>>>;

export function normalizeLang(input: string | null | undefined): Lang | null {
  const s = (input || "").trim().toLowerCase();
  if (!s) return null;
  const primary = s.split("-")[0];
  if (primary === "ua") return "uk";
  if (primary === "de" || primary === "en" || primary === "ru" || primary === "uk" || primary === "it") return primary;
  return null;
}

export function pickLang(params: {
  storedLanguage?: string | null;
  browserLanguage?: string | null;
}): Lang {
  return (
    normalizeLang(params.storedLanguage) ||
    normalizeLang(params.browserLanguage) ||
    "de"
  );
}

export function hasTranslationKey(translations: TranslationMaps, key: string): boolean {
  return Object.values(translations).some((languageTranslations) => languageTranslations != null && key in languageTranslations);
}

export function translateKey(translations: TranslationMaps, lang: Lang, key: string): string {
  return translations[lang]?.[key] ?? key;
}

export function textFor(translations: TranslationMaps, lang: Lang, value: LocalizedText): string {
  if (typeof value === "string") {
    return translateKey(translations, lang, value);
  }
  return value[lang] ?? value.de;
}
